"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWorkspaceTableConfig = void 0;
const store_1 = require("@app/store");
const _1 = require(".");
const is_defined_1 = require("./is-defined");
const useWorkspaceTableConfig = (tableName) => {
    const inspectionReportTableConfig = (0, store_1.useRootSelector)((state) => {
        const isOrg = _1.miscUtil.isDayswapsProInterface();
        const workspaceId = state.workspaceId;
        const organizationId = state.organizationId;
        const id = isOrg ? organizationId : workspaceId;
        if ((0, is_defined_1.isUndefined)(state.tablesConfig))
            return undefined;
        const _table = state.tablesConfig[tableName];
        if ((0, is_defined_1.isUndefined)(_table))
            return undefined;
        if (!(0, is_defined_1.isValue)(id))
            return undefined;
        const workspaceSettings = _table[id] ?? {};
        return Object.assign(workspaceSettings, _table);
    });
    return inspectionReportTableConfig;
};
exports.useWorkspaceTableConfig = useWorkspaceTableConfig;
